import { Tooltip } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { BagStatus, getBagStatusText } from '../../bags/graphql/types/BagTagType';
import { BAG_STATUS_COLORS, CREATION_METHOD_COLORS, FREEZE_HOURS, STATUS_COLORS } from '../constants';
import { BatchStatus, CreationMethod } from '../types';
import { formatBatchTime } from '../utils/formatUtils';

/** 后端返回未约定的枚举值时的兜底样式：显示原值、不抛错（同 wms/tt-exception-orders 的 STATUS_COLORS[value] ?? 'default'） */
const FALLBACK_COLOR = { color: '#4e5969', background: '#f2f3f5', border: '#e5e6eb' };

export const BatchStatusTag: React.FC<{ status: BatchStatus }> = ({ status }) => {
    const { t } = useTranslation();
    const c = STATUS_COLORS[status] ?? FALLBACK_COLOR;
    return (
        <span className="inline-block whitespace-nowrap rounded px-2.5 py-0.5 text-xs" style={{ color: c.color, background: c.background }}>
            {STATUS_COLORS[status] ? t(`wms.sortingBatch.status.${status}`) : status}
        </span>
    );
};

export const CreationMethodTag: React.FC<{ method: CreationMethod }> = ({ method }) => {
    const { t } = useTranslation();
    const c = CREATION_METHOD_COLORS[method] ?? FALLBACK_COLOR;
    return (
        <span className="inline-block whitespace-nowrap rounded px-1.5 text-xs leading-5" style={{ color: c.color, background: c.background }}>
            {CREATION_METHOD_COLORS[method] ? t(`wms.sortingBatch.creationMethod.${method}`) : method}
        </span>
    );
};

export const BagStatusTag: React.FC<{ status: BagStatus }> = ({ status }) => {
    const { t } = useTranslation();
    const c = BAG_STATUS_COLORS[status] ?? FALLBACK_COLOR;
    return (
        <span
            className="inline-block whitespace-nowrap rounded border border-solid px-2 py-0.5 text-xs"
            style={{ color: c.color, background: c.background, borderColor: c.border }}
        >
            {BAG_STATUS_COLORS[status] ? getBagStatusText(status, t) : status}
        </span>
    );
};

/** 「数据已停更」标签，悬浮显示停更时刻 */
export const FrozenTag: React.FC<{ frozenAt?: number }> = ({ frozenAt }) => {
    const { t } = useTranslation();
    if (frozenAt === undefined) return null;
    return (
        <Tooltip title={t('wms.sortingBatch.frozen.tip', { hours: FREEZE_HOURS, time: formatBatchTime(frozenAt) })}>
            <span className="inline-block flex-none cursor-help whitespace-nowrap rounded px-1.5 text-xs leading-[18px]" style={{ color: '#d25f00', background: '#fff7e8' }}>
                {t('wms.sortingBatch.frozen.tag')}
            </span>
        </Tooltip>
    );
};
